/**
 * `summary` XOR `label`, and that is not style.
 *
 * `label` is read ONLY to build the default sentence below, so a caller that
 * passes its own `summary` was handing over a string nothing would ever
 * render — measured on all four Operations screens, which each passed a
 * translated `label` that never reached a reader. The union makes that a
 * compile error instead of a silently discarded translation.
 */
type DataUnavailableProps = {
  /** The admitted producer's reason, safe for display to the workspace user. */
  message: string
  testId: string
} & (
  | {
      /** Cause-specific explanation, authored by the surrounding surface. */
      summary: string
      label?: never
    }
  | {
      summary?: undefined
      /** What is not currently measured, in the words the surrounding screen uses. */
      label: string
    }
)

/**
 * A truthful non-error state for a review lane without an admitted producer.
 *
 * There is deliberately no retry or repair control: capability admission is
 * not something a workspace user can fix by repeating the same read.
 */
export function DataUnavailable({ label, message, summary, testId }: DataUnavailableProps) {
  return (
    <div
      className="rounded-xl border border-border bg-muted/30 p-6 text-center"
      data-testid={testId}
      data-state="unavailable"
      role="status"
    >
      <p className="text-sm font-medium text-foreground">
        {summary ?? `${label}: 아직 측정되지 않았거나 데이터 생산자가 연결되지 않았습니다.`}
      </p>
      <p className="mt-2 text-sm text-muted-foreground">{message}</p>
    </div>
  )
}
